const unaccent = {
  install: (Vue) => {
    Vue.prototype.$unaccent = (object) => {
      if (typeof object !== 'string') {
        return object; // Return the object as is if it's not a string
      }
      return object.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    };
  },
};

export default unaccent;
